module.exports = __webpack_public_path__ + "img/35_11.069f843c.png";